import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../../services/oms-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConstantsService } from '../../services/constants.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  @Input() order_id;
  @Input() isEconConfirmedOrder;
  @Input() isAtHomeOrder;
  @Input() isAtHomeStatus;

  msg:string ="";
  //deleteRequest = {};
  isSuccessMsg :Boolean =false;
  isFailureMsg :Boolean =false;
  headerText : string = "";
  bodyText : string = "";
  statusId: string = "";
  constructor(public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private constantsService: ConstantsService,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    console.log(this.order_id);
    if((this.isAtHomeOrder) && this.isAtHomeStatus == 'accept'){
      this.headerText = 'Mark Order as Accept';
      this.bodyText = 'Are you sure, you want to accept the order ?';
      this.statusId = "2";
    }else if((this.isAtHomeOrder) && this.isAtHomeStatus == 'way'){
      this.headerText = 'Mark Order as On the Way';
      this.bodyText = 'Are you sure, you want to on the way the order ?';
      this.statusId = "3";
    }else if((this.isAtHomeOrder) && this.isAtHomeStatus == 'reached'){
      this.headerText = 'Mark Order as Reached';
      this.bodyText = 'Are you sure, you want to reach the order ?';
      this.statusId = "4";
    }else if((this.isAtHomeOrder) && this.isAtHomeStatus == 'sample'){
      this.headerText = 'Mark Order as Sample Collected';
      this.bodyText = 'Are you sure, you want to sample collect the order ?';
      this.statusId = "5";
    }else if((this.isAtHomeOrder) && this.isAtHomeStatus == 'complete'){
      this.headerText = 'Mark Order as Completed';
      this.bodyText = 'Are you sure, you want to complete the order ?';
      this.statusId = "6";
    }else if((this.isAtHomeOrder) && this.isAtHomeStatus == 'sample_phelp'){
      this.headerText = 'Mark Order as Submit Sample To PHELP';
      this.bodyText = 'Are you sure, you want to submit sample To PHELP ?';
      this.statusId = "101";
    }
  }

    confirmItem() {
    let confirmRequest = {};
    confirmRequest = this.prepareConfirmItemRequest();
    this.SpinnerService.show();
    this.omsServiceService.orderComplete(confirmRequest).subscribe(
      (res) => {

        if(res["status"]==1)
        {
         // alert(res["message"]);
         this.isSuccessMsg =true;
        //  this.msg =res["message"];
         this.toastr.success(res["message"]);
         this._router.navigate(['/orders']);
         this.modal.close(); 
        }else{
          //alert(res["message"]);
          this.isFailureMsg =true;
          // this.msg =res["message"];
          this.toastr.error(res["message"]);
        }
      //  this.modal.close();
        this.SpinnerService.hide();
      }

    )
  }

  confirmEconOrder() {
    let confirmRequest = {};
    console.log(this.order_id);
    confirmRequest["method"] = "OMS/api/operation.php/v1/order/change/status";
    confirmRequest["type"] = "POST";
    confirmRequest["order_id"] = [this.order_id];
    confirmRequest["actionById"] = window.localStorage.getItem('actionById');;
    confirmRequest["actionByName"] = window.localStorage.getItem('actionByName');;
    confirmRequest["source"] = this.constantsService.SOURCE;
    confirmRequest["comment"] = "Order confirmation";
    confirmRequest["reason"] = "Order confirmation";
    confirmRequest["role_id"] = window.localStorage.getItem('role');
    confirmRequest["status"] = "2";
    confirmRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    this.SpinnerService.show();
    this.omsServiceService.orderComplete(confirmRequest).subscribe(
      (res) => {

        if(res["status"]==1)
        {
         // alert(res["message"]);
         this.isSuccessMsg =true;
        //  this.msg =res["message"];
         this.toastr.success(res["message"]);
        //  this._router.navigate(['/orders'], { queryParams: { session: localStorage.getItem("sessionId") } });
         this.modal.close(); 
        }else{
          //alert(res["message"]);
          this.isFailureMsg =true;
          // this.msg =res["message"];
          this.toastr.error(res["message"]);
        }
      //  this.modal.close();
        this.SpinnerService.hide();
      }

    )
  }

  confirmAtHomeOrder() {
    console.log(this.order_id);
    this.SpinnerService.show();
      if(this.statusId == "101"){
          let processRequest = {};
          processRequest["service"] = "OMS/api/operation.php/v1/order/processing/sample_submission";
          processRequest["requestType"] = "post";
          processRequest["submissionType"] = "1";
          processRequest["isInternalCall"] = 1;
          processRequest["channelCode"] = 2;
          processRequest["order_ids"] = [this.order_id];
          console.log(`submissionRequest`,processRequest )
            this.omsServiceService.processingSubmission(processRequest).subscribe(
              (res:any) => {
                 console.log(`submissionResponse`,res )
                if (res.status == 1) {
                  this.toastr.success(res.message);
                  this.modal.close(); 
                }else{
                  this.toastr.error(res.message);
              }
            })
      }else if(this.isAtHomeStatus == 'complete'){
        let confirmRequest = {};
        confirmRequest["method"] = "OMS/api/operation.php/v1/orders/complete/manually";
        confirmRequest["type"] = "POST";
        confirmRequest["actionById"] = window.localStorage.getItem('actionById');;
        confirmRequest["actionByName"] = window.localStorage.getItem('actionByName');;
        confirmRequest["source"] = this.constantsService.SOURCE;
        confirmRequest["comment"] = this.headerText;
        confirmRequest["reason"] = this.isAtHomeStatus;
        confirmRequest["role"] = window.localStorage.getItem('role');
        confirmRequest["status"] = this.statusId;
        confirmRequest["isInternalCall"] = 1;
        //confirmRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
        
        if(window.location.pathname.includes('/escalation-details/')){
          confirmRequest["order_ids"] =[ this.order_id];
        }else{
          confirmRequest["order_ids"] = this.order_id;
        }
        
        this.omsServiceService.orderComplete(confirmRequest).subscribe(
          (res) => {

            if(res["status"]==1)
            {
            // alert(res["message"]);
            this.isSuccessMsg =true;
            //  this.msg =res["message"];
            this.toastr.success(res["message"]);
            //  this._router.navigate(['/orders'], { queryParams: { session: localStorage.getItem("sessionId") } });
            this.modal.close(); 
            }else{
              //alert(res["message"]);
              this.isFailureMsg =true;
              // this.msg =res["message"];
              this.toastr.error(res["message"]);
            }
          //  this.modal.close();
          }

        )
      }else {
      let confirmRequest = {};
      confirmRequest["method"] = "OMS/api/operation.php/v1/order/change/status";
      confirmRequest["type"] = "POST";
      confirmRequest["order_id"] = [this.order_id];
      confirmRequest["actionById"] = window.localStorage.getItem('actionById');;
      confirmRequest["actionByName"] = window.localStorage.getItem('actionByName');;
      confirmRequest["source"] = this.constantsService.SOURCE;
      confirmRequest["comment"] = this.headerText;
      confirmRequest["reason"] = this.isAtHomeStatus;
      confirmRequest["role_id"] = window.localStorage.getItem('role');
      confirmRequest["status"] = this.statusId;
      confirmRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
      
      this.omsServiceService.orderComplete(confirmRequest).subscribe(
        (res) => {

          if(res["status"]==1)
          {
          // alert(res["message"]);
          this.isSuccessMsg =true;
          //  this.msg =res["message"];
          this.toastr.success(res["message"]);
          //  this._router.navigate(['/orders'], { queryParams: { session: localStorage.getItem("sessionId") } });
          this.modal.close(); 
          }else{
            //alert(res["message"]);
            this.isFailureMsg =true;
            // this.msg =res["message"];
            this.toastr.error(res["message"]);
          }
        //  this.modal.close();
        }

      )
    }

        this.SpinnerService.hide();
  }

  prepareConfirmItemRequest() {
    let confirmRequest = {};
    confirmRequest["order_id"] = this.order_id;
    confirmRequest["actionById"] = window.localStorage.getItem('actionById');
    confirmRequest["actionByName"] = window.localStorage.getItem('actionByName');
    confirmRequest["status"] = 6;
    confirmRequest["source"] = "CCO";
    confirmRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    confirmRequest["reason"] = "test";
    return confirmRequest;
  }

  modelClose()
  {
    this.modal.close();    
  }

}
